<template>
    <div class="B2BReviews border-gray-200 dark:border-default bg-gray-100 dark:bg-subtle">
        <div class="container flex flex-col border-t border-solid py-10 lg:pt-20">
            <div class="flex flex-row">
                <CHeading class="xl:w-2/3" tag="h2" variant="fat-italic">
                    Skúsenosti našich partnerov <br class="hidden lg:block" />
                    zapojených v GROWNi
                </CHeading>

                <div v-if="showPagination" class="mt-10 hidden h-fit w-1/3 flex-row justify-end xl:flex">
                    <CButton
                        class="size-14 rotate-180"
                        icon="chevron-right"
                        variant="primary-outline"
                        @click="handlePageChange(-1)"
                    />

                    <CButton
                        class="ml-2 size-14"
                        icon="chevron-right"
                        variant="primary-outline"
                        @click="handlePageChange(1)"
                    />
                </div>
            </div>

            <div class="relative mt-12 flex flex-col xl:flex-row">
                <B2BReviewCard
                    v-for="(reviewName, idx) in currentReviews"
                    :key="reviewName"
                    :class="{
                        'rounded-t-2xl border-b border-solid border-gray-200 dark:border-default xl:mb-12 xl:border-0': !idx,
                        'h-fit rounded-b-2xl xl:relative xl:left-0 xl:top-0 xl:ml-4': idx,
                        'rounded-2xl': currentReviews.length === 1
                    }"
                    :review="reviews[reviewName]"
                />
            </div>

            <div v-if="showPagination" class="mt-10 flex h-fit w-full flex-row justify-end xl:hidden">
                <CButton
                    class="size-14 rotate-180"
                    icon="chevron-right"
                    variant="primary-outline"
                    @click="handlePageChange(-1)"
                />

                <CButton
                    class="ml-2 size-14"
                    icon="chevron-right"
                    variant="primary-outline"
                    @click="handlePageChange(1)"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { B2BType } from '#shared/types/B2B'
import CHeading from '@/components/ui/CHeading.vue'
import CButton from '@/components/ui/CButton.vue'
import B2BReviewCard from '@/components/b2b/B2BReviewCard.vue'

const props = defineProps({
    type: {
        type: String as () => B2BType,
        default: B2BType.DEFAULT
    }
})

const REVIEWS = {
    'stat-1': {
        title: 'Našli sme kvalitných motivovaných profesionálov',
        message:
            'Neviem si vynachváliť podporu a spoluprácu pri hľadaní kvalitných a motivovaných profesionálov do služby štátu. Ľudia sú základ. Túto krajinu zmeníme k lepšiemu, len ak sa ľudia s víziou a líderstvom rozhodnú ju zmeniť zvnútra. A v tom je LEAF pre nás - úradníkov - neoceniteľným partnerom. Ďakujeme za to.',
        name: 'Ján Hargaš',
        img: '/images/coop/jan-hargas.png',
        job: 'Ministerstvo investícií, regionálneho rozvoja a informatizácie Slovenskej republiky',
        type: 'Štát',
        link: 'https://www.mirri.gov.sk/'
    },
    'firma-1': {
        title: 'Stal sa ambasádorom GROWNi GROWps',
        message:
            'Príležitosť byť ambasádorom GROWNi GROWps mi umožnila stretnúť skupinu profesionálov s bohatými skúsenosťami z rôznych firiem a odvetví.',
        name: 'Matej Ďuríček',
        img: '/images/coop/matej-duricek.png',
        job: 'Google',
        type: 'Firma',
        link: 'https://www.google.sk/'
    },
    'firma-2': {
        title: 'Stala sa ambasádorkou GROWNi GROWps',
        message:
            'Ambasádorstvo pre GROWNi GROWps bola skvelá skúsenosť pre zdieľanie skúsenosti a osvedčených postupov, ktoré sme potom individuálne vyskúšali v praxi.',
        name: 'Zuzka Miková',
        img: '/images/coop/zuzka-mikova.png',
        job: 'VESTBERRY',
        type: 'Firma',
        link: 'https://vestberry.com/'
    },
    'neziskovka-1': {
        title: 'Spolupracujeme',
        message:
            'Som presvedčená, že GROWNi vytvára pre každého jednotlivca, organizáciu a Slovensko jedinečnú príležitosť spoločnými silami byť lepším.',
        name: 'Mária Bieliková',
        img: '/images/coop/maria-bielikova.png',
        job: 'KInIT',
        type: 'Neziskovka',
        link: 'https://kinit.sk/'
    }
} as const

const CONTENT = {
    [B2BType.DEFAULT]: ['stat-1', 'firma-1', 'firma-2', 'neziskovka-1'],
    [B2BType.GOV]: ['stat-1'],
    [B2BType.NGO]: []
} as const

const page = ref(0)
const reviews = REVIEWS
const content = CONTENT[props.type]
const totalPages = Math.ceil(content.length / 2)

const showPagination = computed(() => totalPages > 1)

const currentReviews = computed(() => {
    return content.slice(page.value * 2, page.value * 2 + 2)
})

const handlePageChange = (direction: 1 | -1) => {
    const nextPage = page.value + direction

    if (nextPage < 0) {
        page.value = totalPages - 1
    } else if (nextPage >= totalPages) {
        page.value = 0
    } else {
        page.value = nextPage
    }
}
</script>